import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import type { IReduxState } from '../../../../../configureStore';
import type { IEmbloomQuestionnaire } from '../../../../interfaces/embloomQuestionnaire';
import type { INewProcessCustomControls } from '../../../home/newProcess/customControls/iNewProcessCustomControls';
import { fetchJson } from '../../../../../store/fetch';
import { translateKey } from '../../../../../translate';
import { ProcessStartWizardCol } from '../../../../elements/ProcessStartWizard/ProcessStartWizardCol';
import { ProcessStartWizardRow } from '../../../../elements/ProcessStartWizard/ProcessStartWizardRow';
import { DropDownTileSelectContainer } from './dropDownTileSelect/DropDownTileSelectContainer';

interface IServiceOrganizationQuestionnaires {
    embloomQuestionnaire: IEmbloomQuestionnaire;
}

interface IGgzoEmblActionBarProps extends INewProcessCustomControls {
    hideLabel?: boolean;
}

export function GgzoEmblActionBar(props: IGgzoEmblActionBarProps) {
    const [serviceOrganizationQuestionnaires, setServiceOrganizationQuestionnaires] = useState<
        IServiceOrganizationQuestionnaires[]
    >([]);
    const organizationId = useSelector((state: IReduxState) => state.authentication.organizationId);

    useEffect(() => {
        loadQuestionnaires();
    }, []);

    return (
        <ProcessStartWizardRow label={props.hideLabel ? undefined : translateKey('home.chooseStartResearch_action')}>
            <ProcessStartWizardCol>
                {serviceOrganizationQuestionnaires.length > 0 && (
                    <DropDownTileSelectContainer
                        questionnaires={serviceOrganizationQuestionnaires.map((item) => item.embloomQuestionnaire)}
                        setNewProcessCustomIdentifier={props.setNewProcessCustomIdentifier}
                    />
                )}
            </ProcessStartWizardCol>
        </ProcessStartWizardRow>
    );

    async function loadQuestionnaires() {
        const serviceOrganizationSettingUrl = `/api/serviceOrganizationSettings?serviceId=${props.service.id}&organizationId=${organizationId}&isActive=true`;
        const serviceOrganizationSettingResult = await fetchJson(serviceOrganizationSettingUrl, 'GET');

        if (serviceOrganizationSettingResult.json.items[0]) {
            const embloomQuestionnaireServiceOrganizationSettingUrl = `/api/serviceServiceOrganizationSettings/${serviceOrganizationSettingResult.json.items[0].id}/embloomQuestionnaireServiceOrganizationSettings`;
            const embloomQuestionnaireServiceOrganizationSettingResult = await fetchJson(
                embloomQuestionnaireServiceOrganizationSettingUrl,
                'GET'
            );
            setServiceOrganizationQuestionnaires(embloomQuestionnaireServiceOrganizationSettingResult.json.items);
        }
    }
}
